import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useGetMyProductLicensesQuery } from '@/store/api/apiSlice';
import type { ProductId } from '@/config/products';
import { UserRole } from '@/types';
import { resolveAuthenticatedHome } from '@/utils/productLicense';

/** Role-aware home redirect — unlicensed members go to awaiting-access, not Plan. */
export default function AuthenticatedHomeRedirect() {
  const { user } = useAuth();
  const role = user?.role;

  const { data, isLoading, isError } = useGetMyProductLicensesQuery(undefined, {
    skip: !user || role === UserRole.SUPER_ADMIN,
  });

  if (role === UserRole.SUPER_ADMIN) {
    return <Navigate to="/admin" replace />;
  }

  if (isLoading) {
    return (
      <div className="min-h-[40vh] flex items-center justify-center bg-gray-50" />
    );
  }

  // Soft-fail: API error → treat license state as unknown (legacy route), not empty seats.
  const launchable = isError
    ? null
    : ((data?.launchableProductIds ?? []) as ProductId[]);

  return (
    <Navigate
      to={resolveAuthenticatedHome({
        role,
        settings: user?.tenant?.settings as Record<string, unknown> | undefined,
        launchableProductIds: launchable,
      })}
      replace
    />
  );
}
